<nz-layout class="height-full">
    <nz-sider nzTheme="light" nzWidth="351px">
        <div class="am-dash-sider-container">
            <div class="am-dash-filter-panel am-dash-sider-content">
                <div>
                    <app-saved-dashboard-view></app-saved-dashboard-view>
                </div>
                <div *ngFor="let link of [modify_time_ads_datasource]">
                    <app-data-text
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-data-text>
                </div>
                <app-single-select
                    [option]="settingItemDateAggregation.options"
                ></app-single-select>
                <app-toggle [option]="settingItemCurrency.options"></app-toggle>
                <div *ngFor="let link of values(filterDashboardItemLinks)">
                    <!-- TODO Obsłużyć pozostałe typy -->
                    <app-category-filter-dashboard-item
                        *ngIf="
                            link.dashboardItemFactory.componentClass ==
                            'CategoryFilterDashboardItem'
                        "
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    >
                    </app-category-filter-dashboard-item>
                    <app-date-picker
                        *ngIf="
                            link.dashboardItemFactory.componentClass ==
                            'DateRangeFilterDashboardItem'
                        "
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    >
                        ></app-date-picker
                    >
                    <app-segment-filter
                        *ngIf="
                            link.dashboardItemFactory.componentClass ==
                            'SegmentsFilterDashboardItem'
                        "
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-segment-filter>
                </div>
            </div>
            <div class="am-dash-sider-footer">
                <div>
                    <div class="am-dash-filter-footer-content">
                        <button
                            nz-button
                            nzType="primary"
                            (click)="applyChangedFilters()"
                            [disabled]="isApplyButtonDisabled"
                            style="flex-grow: 1"
                        >
                            Apply
                        </button>
                    </div>
                    <div class="am-dash-filter-footer-content">
                        <button
                            nz-button
                            color="primary"
                            (click)="standardDashboardInitialize()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Restore defaults
                        </button>
                        <button
                            nz-button
                            color="primary"
                            (click)="reloadData()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Reload data
                        </button>
                        <button
                            nz-button
                            color="primary"
                            (click)="requestNewSegmentsProcessing()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Process new Segments
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </nz-sider>
    <nz-content class="am-dash-main-content">
        <div class="am-dash-legend-card">
            <div nz-row [nzGutter]="5">
                <div nz-col nzSpan="24">
                    <app-common-legend></app-common-legend>
                </div>
            </div>
        </div>
        <div class="main-container">
            <div class="grid-container">
                <div nz-row [nzGutter]="5">
                    <div
                        nz-col
                        nzSpan="12"
                        *ngFor="let link of [ads_revenue_user_level]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div
                        nz-col
                        nzSpan="12"
                        *ngFor="let link of [ads_revenue_platform_report]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
                <div nz-row [nzGutter]="5">
                    <div
                        nz-col
                        nzSpan="8"
                        *ngFor="let link of [ads_running_arpu]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div nz-col nzSpan="8" *ngFor="let link of [ads_arpdau]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div nz-col nzSpan="8" *ngFor="let link of [ads_arpdeu]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
                <div nz-row [nzGutter]="5">
                    <div
                        nz-col
                        nzSpan="8"
                        *ngFor="let link of [ads_engagement_rate]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div nz-col nzSpan="8" *ngFor="let link of [impressions]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div
                        nz-col
                        nzSpan="8"
                        *ngFor="let link of [impressions_per_deu]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
                <div nz-row [nzGutter]="5">
                    <div
                        nz-col
                        nzSpan="8"
                        *ngFor="let link of [completion_rate]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div nz-col nzSpan="8" *ngFor="let link of [app_fill_rate]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div
                        nz-col
                        nzSpan="8"
                        *ngFor="let link of [errors_per_ad_watch_click]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
                <div nz-row [nzGutter]="5">
                    <div nz-col nzSpan="8" *ngFor="let link of [ecpm]">
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div
                        nz-col
                        nzSpan="8"
                        *ngFor="let link of [comparison_impressions]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                    <div
                        nz-col
                        nzSpan="8"
                        *ngFor="let link of [comparison_revenue]"
                    >
                        <app-echarts-dashboard-item
                            [dashboardItemFactory]="link.dashboardItemFactory"
                            [dataLoaderEmitter]="link.dataLoaderEmitter"
                        ></app-echarts-dashboard-item>
                    </div>
                </div>
            </div>
        </div>
    </nz-content>
</nz-layout>
